import moment from 'moment';
import { SearchQuery } from 'packages/omnitag/state/text-search';
import { OmnitagFilter } from 'packages/lib/api/omnitag/contract/omnitag-filters';

const MAX_NBR_OUTPUTS_PARAM = 'maxNbrOutputs';

/** Page size for the single API fetch; uses maxNbrOutputs filter when set */
export function getSearchFetchPageSize(query: SearchQuery): number {
  const maxNbrOutputs = query[MAX_NBR_OUTPUTS_PARAM];
  if (typeof maxNbrOutputs === 'number' && maxNbrOutputs > 0) {
    return maxNbrOutputs;
  }
  return 10_000;
}

/** POST body for /vision/search. UI pageNo/pageSize are not sent — pagination is client-side. */
export function getOTSearchPOSTBody(
  query: SearchQuery,
  dynamicFilters: OmnitagFilter[]
): Record<string, unknown> {
  const body: Record<string, unknown> = {
    tagName: query.text,
    pageNo: 1,
    pageSize: getSearchFetchPageSize(query),
  };

  if (query.logNames && query.logNames.length > 0) {
    body['logNames'] = query.logNames;
  }

  for (const filter of dynamicFilters) {
    if (filter.filterType === 'dateRange') {
      const from = query[`${filter.paramName}From`];
      const to = query[`${filter.paramName}To`];
      if (from) {
        body[`${filter.paramName}From`] = moment(from)
          .utcOffset(0)
          .format('YYYY-MM-DD');
      }
      if (to) {
        body[`${filter.paramName}To`] = moment(to)
          .utcOffset(0)
          .format('YYYY-MM-DD');
      }
    } else {
      const value = query[filter.paramName];
      const valueStr = value as string;
      if (value !== undefined && value !== null) {
        if (filter.filterType === 'select' && Array.isArray(value)) {
          if ((value as string[]).length > 0) {
            body[filter.paramName] = value;
          }
        } else if (
          filter.filterType === 'text' &&
          typeof value === 'string' &&
          valueStr.length > 0
        ) {
          body[filter.paramName] = valueStr.split(',');
        } else if (
          filter.filterType === 'number' &&
          typeof value === 'number'
        ) {
          body[filter.paramName] = value;
        } else if (
          filter.filterType === 'toggle' &&
          typeof value === 'boolean'
        ) {
          body[filter.paramName] = value;
        }
      }
    }
  }

  return body;
}
